export const stringToCurrency = (amount) => {
  const formatter = new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN"
  });

  return !isNaN(amount) ? formatter.format(amount) : 0;
};
